<template>
  <div>
    <el-input v-model="searchFileName" size="mini" placeholder="输入关键字搜索" style="width: 200px;" />
    <el-button type="primary" :icon="Search" @click="getData()">搜索</el-button>
  </div>
  <el-scrollbar max-height="800px">
    <el-table v-loading="loading" :data="formattedItems" style="width: 100%">
      <el-table-column fixed prop="uuid" label="文件UUID" width="150" />
      <el-table-column prop="fileName" label="文件名称" width="120" />
      <el-table-column prop="content" label="文件内容" width="120" />
      <el-table-column prop="fileUrl" label="完整文件路径" width="120" />
      <el-table-column prop="fileExtension" label="文件后缀" width="120" />
      <el-table-column prop="fileSize" label="文件大小" width="120" />
      <el-table-column prop="fileType" label="文件类型" width="120" />
      <el-table-column prop="fileSrc" label="文件路径" width="120" />
      <el-table-column prop="levelId" label="层级" width="120" />
      <el-table-column prop="time" label="创建时间" width="120" />
      <el-table-column prop="fileSrc" fixed="right" label="图片" width="120">
        <template v-slot="scope">
          <el-image v-if="scope && scope.row" style="width: 100px; height: 100px" :src="scope.row.fileUrl" />
          <span v-else>无图片</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template v-slot="scope">
          <RouterLink :to="handleUpdate(scope.row)"><el-button link type="primary" size="small">修改</el-button>
          </RouterLink>
          <el-button link type="primary" size="small" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-scrollbar>
  <el-pagination background layout="prev, pager, next" :page-size="pageSize" :current-page="currentPage"
    :total="totalCount" @current-change="handleCurrentChange" style="margin: 10px 0 ;" />
</template>

<script>
const axios = require("axios");
import { ref } from "vue";
const loading = ref(true);
import { inject } from 'vue'

export default {
  name: "FilesView",
  data() {
    return {
      serverUrl: inject('serverUrl'),
      fileUrl: inject('fileUrl'),
      searchFileName: "",
      pageSize: 5,
      currentPage: 1,
      loading: true,
      tableData: [],
      totalCount: 0,
      src: "https://th.bing.com/th/id/OIP.OhUOhPbzdELTIt6QY9fV0AHaEo?rs=1&pid=ImgDetMain",
      role: sessionStorage.getItem("role"),
      zh: sessionStorage.getItem("zh"),
    };
  },

  computed: {
    formattedItems() {
      return this.tableData.map(item => ({
        ...item, // 保留其他属性
        time: (item.writetime.year + 1900) + "-" + (item.writetime.month + 1) + "-" + item.writetime.date + " " + item.writetime.hours + ":" + item.writetime.minutes + ":" + item.writetime.seconds, // 格式化时间
        fileUrl: this.fileUrl + item.fileSrc
      }));
    },
  },
  mounted() {
    console.log("文件管理页面");
    try {
      this.getData();
    } catch (e) {
      console.log("错误", e);
    }
  },

  methods: {
    handleUpdate(row) {
      return "/updateproduct/" + row._id;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    async getData() {
      var that = this;
      this.loading = true;
      const res = await axios.post(
        this.serverUrl + "/api/files/get", // 请求后端的 URL
        {
          "fileName": that.searchFileName,
          "limit": that.pageSize,
          "offset": (that.currentPage - 1) * that.pageSize
        },
        {
          headers: {
            "Content-Type": "application/json;charset=utf-8",
            "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
            "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
          },
        }
      );
      console.log(res);
      that.tableData = res.data.obj.toolsFiles;
      that.totalCount = res.data.obj.fileCount;
      that.loading = false;
      console.log(that.totalCount);
      /*
      if (this.role == '系统管理员') {
        axios.get('/api/product')
          .then(function (response) {
            console.log("查询商品信息");
            console.log(response);
            var list = response.data.data
            that.tableData = list

            for (let i = 0; i < list.length; i++) {

              var tp = list[i].tp

              // 去除外层双引号，然后将 \" 替换为 "
              const fixedStr = tp.replace(/^"|"$/g, '').replace(/\\"/g, '"');

              // 将字符串解析为对象数组
              const objArray = JSON.parse(fixedStr);
              that.tableData[i].tp = objArray

            }
            that.loading = false
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            // 总是会执行
          });
      } else {
        var form = {
          zh: this.zh
        }
        const res = await axios.post(
          "/api/getnonghu/product", // 请求后端的 URL
          form,
          {
            headers: {
              "Content-Type": "application/json;charset=utf-8",
              "Access-Control-Allow-Origin": "*", // 允许所有域名访问，或者设置为特定的域名
              "Access-Control-Allow-Methods": "GET, POST, OPTIONS", // 允许的请求方法
              "Access-Control-Allow-Headers": "Content-Type", // 允许的请求头
            },
          }
        );

        var list = res.data.data
        that.tableData = list

        for (let i = 0; i < list.length; i++) {

          var tp = list[i].tp

          // 去除外层双引号，然后将 \" 替换为 "
          const fixedStr = tp.replace(/^"|"$/g, '').replace(/\\"/g, '"');

          // 将字符串解析为对象数组
          const objArray = JSON.parse(fixedStr);
          that.tableData[i].tp = objArray

        }

        that.loading = false
      }
*/
    },
    handleDelete(row) {
      var that = this;
      console.log(row);
      this.loading = true;
      axios
        .post(this.serverUrl + "/api/removeproduct", { _id: row._id })
        .then(function (response) {
          that.getData();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          // 总是会执行
        });
    },
    getFirstPicture(row) {
      console.log(row);
      console.log("渲染每一层图片", row);
      if (row.pictures && row.pictures.length > 0) {
        return row.pictures[0];
      } else {
        return "https://www.keaitupian.cn/cjpic/frombd/2/253/2107631312/3178897554.jpg"; // 或者你认为合适的默认图片地址
      }
    },
  },
};
</script>
